import {useEffect} from 'react';
import {useLocalStorage} from '../../../hooks/useLocalStorage';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {InvitationFormSchema} from '../invitationFormProps';

export const useInvitationState = (
  storageKey:
    | 'toInvite'
    | 'invited'
    | 'declined'
    | 'uncontactable'
    | 'today'
    | 'completed'
    | 'scheduled'
) => {
  const [_, setLocalStorage] = useLocalStorage<
    InvitationFormSchema | Record<string, never>
  >(storageKey, {});
  const {values} = useAutoForm<InvitationFormSchema>();

  useEffect(() => {
    setLocalStorage(values);
  }, [values, setLocalStorage]);

  return {values};
};
